export default __webpack_public_path__ + "static/media/wonton-noodles.4010156d.png";